import { createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    notifications: [],
    currentNotification: null,
    totalNotifications: 0,
    loading: false,
    detailLoading: false,
    saving: false,
    error: null,
    success: false,
    deleteSuccessCount: 0,
    bulkDeleting: false,
    bulkCompletedAt: 0,
    logs: {
      items: [],
      totalLogs: 0,
      loading: false,
      error: null,
    },
    stats: {
      data: null,
      loading: false,
      error: null,
    },
  },
  reducers: {
    getNotificationsAction: (state) => {
      state.loading = true;
      state.error = null;
    },
    getNotificationsSuccess: (state, action) => {
      const responseData = action.payload?.results || action.payload?.data || [];
      state.notifications = Array.isArray(responseData) ? responseData : [];
      state.totalNotifications = action.payload?.count ?? state.notifications.length;
      state.loading = false;
      state.error = null;
    },
    getNotificationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getNotificationByIdAction: (state) => {
      state.detailLoading = true;
      state.error = null;
    },
    getNotificationByIdSuccess: (state, action) => {
      state.currentNotification = action.payload?.data || action.payload;
      state.detailLoading = false;
      state.error = null;
    },
    getNotificationByIdFailure: (state, action) => {
      state.detailLoading = false;
      state.error = action.payload;
      state.currentNotification = null;
    },
    clearCurrentNotification: (state) => {
      state.currentNotification = null;
    },
    createNotificationAction: (state) => {
      state.saving = true;
      state.error = null;
      state.success = false;
    },
    createNotificationSuccess: (state) => {
      state.saving = false;
      state.error = null;
      state.success = true;
    },
    createNotificationFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
      state.success = false;
    },
    resetNotificationSuccess: (state) => {
      state.success = false;
      state.error = null;
    },
    deleteNotificationAction: (state) => {
      state.saving = true;
      state.error = null;
    },
    deleteNotificationSuccess: (state) => {
      state.saving = false;
      state.error = null;
      state.deleteSuccessCount += 1;
    },
    deleteNotificationFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },
    bulkDeleteNotificationsAction: (state) => {
      state.bulkDeleting = true;
      state.error = null;
    },
    bulkDeleteNotificationsSuccess: (state) => {
      state.bulkDeleting = false;
      state.bulkCompletedAt += 1;
    },
    bulkDeleteNotificationsFailure: (state, action) => {
      state.bulkDeleting = false;
      state.error = action.payload;
    },
    getNotificationLogsAction: (state) => {
      state.logs.loading = true;
      state.logs.error = null;
    },
    getNotificationLogsSuccess: (state, action) => {
      const responseData = action.payload?.results || action.payload?.data || [];
      state.logs.items = Array.isArray(responseData) ? responseData : [];
      state.logs.totalLogs = action.payload?.count ?? state.logs.items.length;
      state.logs.loading = false;
      state.logs.error = null;
    },
    getNotificationLogsFailure: (state, action) => {
      state.logs.loading = false;
      state.logs.error = action.payload;
    },
    getNotificationStatsAction: (state) => {
      state.stats.loading = true;
      state.stats.error = null;
    },
    getNotificationStatsSuccess: (state, action) => {
      state.stats.data = action.payload;
      state.stats.loading = false;
      state.stats.error = null;
    },
    getNotificationStatsFailure: (state, action) => {
      state.stats.loading = false;
      state.stats.error = action.payload;
    },
  },
});

export const {
  getNotificationsAction,
  getNotificationsSuccess,
  getNotificationsFailure,
  getNotificationByIdAction,
  getNotificationByIdSuccess,
  getNotificationByIdFailure,
  clearCurrentNotification,
  createNotificationAction,
  createNotificationSuccess,
  createNotificationFailure,
  resetNotificationSuccess,
  deleteNotificationAction,
  deleteNotificationSuccess,
  deleteNotificationFailure,
  bulkDeleteNotificationsAction,
  bulkDeleteNotificationsSuccess,
  bulkDeleteNotificationsFailure,
  getNotificationLogsAction,
  getNotificationLogsSuccess,
  getNotificationLogsFailure,
  getNotificationStatsAction,
  getNotificationStatsSuccess,
  getNotificationStatsFailure,
} = notificationSlice.actions;

export { notificationSlice };
